// extracted by mini-css-extract-plugin
module.exports = {"container":"i_a","actions":"i_b","product-link":"i_c","logo":"i_d"};